<template>
	<div class="expect-job">
		<basic-info></basic-info>
		<job-intention ref="intention"></job-intention>
		<privacy-setting></privacy-setting>
		<div class="basic-info-save-box">
			<div
			 class="page-btn"
			 :class="{'btn-disabled': !expectionInfoOk}"
			 @click="saveResumeEvent"
			>{{btnText}}</div>
		</div>
		<toast
		 v-model="showToast"
		 :time="time"
		>{{errorInfo}}</toast>
		<loading v-model="showLoading"></loading>
	</div>
</template>
<script>
import basicInfo from "./basicInfo";
import jobIntention from "./jobIntention";
import privacySetting from "./privacySetting";
import util from "../../util";
import { CallbackFn } from "./CallbackFn";
import { showISDCaptcha } from "./showISDCaptcha";
import { Toast, Loading } from "@58fe/v5";
import { mapGetters } from "vuex";
export default {
	components: {
		basicInfo,
		jobIntention,
		privacySetting,
		Toast,
		Loading
	},
	data() {
		return {
			showToast: false,
			errorInfo: "",
			time: 1500,
			showLoading: false,
			isFirstClick: true, // 防止重复点击
			nameObj: {
				zpcateId: "期望职位",
				salary: "期望薪资",
				targetAreaId: "求职区域"
			},
			fromPageName: util.getParamVal("platform") || ""
		};
	},
	computed: {
		...mapGetters([
			"expectionInfoOk",
			"expectionInfo",
			"submitState",
			"submitErrorInfo",
			"privacySettingState",
			"privacyErrorInfo",
			"resumeId",
			"resumeType",
			"pagefromUrl",
			"pagefromLog",
			"pagetypeLog",
			"deliveryCode",
			"deliveryMsg",
			"deliveryState",
			"infoId",
			"pagefrom",
			"showISDCaptcha",
			"responseObj",
			"areaInfo"
		]),
		btnText: function() {
			return this.pagefrom === "fromEducation"
				? "创建并报名成功"
				: "创建基础简历";
		}
	},
	watch: {
		privacySettingState(val) {
			// 隐私设置失败若页面还没进行跳转进行提示
			if (val === false) {
				this.errorInfo = this.privacyErrorInfo;
				this.showToast = true;
			}
		}
	},
	created() {
		if (this.areaInfo.length < 1) {
			// 获取上一份简历基本信息
			this.$store.dispatch("getLastResumeInfo");

			// 获取账号绑定的手机号
			this.$store.dispatch("checkMobileAuth");

			// 获取用户隐私设置
			this.$store.dispatch("getPrivacy");

			// 获取区域
			this.$store.dispatch("getAreaInfo");
		}
		if (util.getParamVal("comefrom") === "auth") {
			this.$v5
				.confirm({
					title: "提示",
					text: "认证成功，点击保存进行下步流程",
					confirmText: "保存",
					cancelText: "取消"
				})
				.then(res => {
					if (res) {
						this.saveResumeEvent();
					}
				});
		}
	},
	mounted() {
		// 添加按下态监听
		let DomList = Array.prototype.slice.call(
			document.getElementsByClassName("expect-job-detail")
		);

		DomList.forEach((item, index) => {
			item.addEventListener("touchstart", function(e) {
				this.parentNode.className += " item-active";
			});
			item.addEventListener("touchmove", function(e) {
				this.parentNode.className = this.parentNode.className.replace(
					/item-active/g,
					""
				);
			});
			item.addEventListener("touchend", function(e) {
				this.parentNode.className = this.parentNode.className.replace(
					/item-active/g,
					""
				);
			});
		});

		window.clickLog &&
			window.clickLog("from=targetpage_normal_all" + this.pagetypeLog);

		window.clickLog &&
			window.clickLog("from=targetpage_normal" + this.pagefromLog);

		// 校招来源埋点
		this.pagefrom === "fromXZ" &&
			window.clickLog &&
			window.clickLog("from=xiaozhao_resumecreate2_show");
		this.pagefrom === "fromCQXZ" &&
			window.clickLog &&
			window.clickLog("from=chongqingxiaozhao_resumecreate2_show");

		if(this.pagefrom === "fromWX"&&this.fromPageName==="mp"){
			window.clickLog &&
			window.clickLog("from=58yg_nojlpost_page2_show");
		}else if(this.pagefrom === "fromWX"){
			window.clickLog &&
			window.clickLog("from=58yg_jlpost_page2_show");
		}
	},
	methods: {
		async saveResumeEvent() {
			window.clickLog &&
				window.clickLog("from=jl_baocunall_all" + this.pagetypeLog);
			window.clickLog &&
				window.clickLog("from=jl_baocunall" + this.pagefromLog);

			if (this.expectionInfoOk && this.isFirstClick) {
				window.clickLog &&
					window.clickLog("from=jl_baocunclk" + this.pagetypeLog);
				window.clickLog &&
					window.clickLog("from=jl_baocunclk" + this.pagefromLog);

				this.saveResume();
			} else {
				// 未填写的项进行错误提示
				let obj = this.expectionInfo,
					isFirstError = true;
				for (let prop in obj) {
					// 第一个错误信息toast提示，错误样式处理只需触发为空的项
					if (
						isFirstError &&
						obj.hasOwnProperty(prop) &&
						!obj[prop]
					) {
						this.errorInfo =
							"您的" + this.nameObj[prop] + "填写有误，请修改";
						this.showToast = true;
						isFirstError = false;
					}
					if (obj.hasOwnProperty(prop) && !obj[prop]) {
						this.$refs.intention.checkNull(prop);
					}
				}
			}
		},
		// 保存简历请求
		async saveResume() {
			/*
			*简历发布来源：微信：70百度：71头条：70支付宝：70
			*/
			if([70,71].indexOf(parseInt(util.getParamVal('sourceid'),10)) > -1) {
				window.clickLog && clickLog("from=save_click");
			}

			if(this.pagefrom === "fromWX" && this.fromPageName === "mp"){
				window.clickLog &&
					window.clickLog("from=58yg_nojlpost_success_click");
			}else if(this.pagefrom === "fromWX" ){
					window.clickLog &&
					window.clickLog("from=58yg_jlpost_success_click");
			}

			this.isFirstClick = false;
			this.showLoading = true;
			await this.$store.dispatch("saveResume");

			// 如果发布成功,请求保存隐私接口，然后跳转丰富页面（联盟/小程序跳转回来源页面）
			if (this.submitState) {
				// 隐私设置
				this.$store.dispatch("setPrivacy");

				// 简历进行投递
				if (this.infoId) {
					await this.$store.dispatch("delivery");
				}
				this.showLoading = false;
				let callbackFn = new CallbackFn(
					this.pagefromUrl,
					this.deliveryCode,
					this.resumeId,
					this.$v5,
					this.deliveryMsg,
					this.deliveryState
				);
				callbackFn[this.pagefrom]
					? callbackFn[this.pagefrom]()
					: callbackFn["default"]();
			} else if (this.showISDCaptcha) {
				showISDCaptcha(this.responseObj, this.saveResume);
				this.isFirstClick = true; // 重新设置为可点击
			} else {
				this.isFirstClick = true; // 重新设置为可点击
				this.errorInfo = this.submitErrorInfo;
				this.showToast = true;
			}
			this.showLoading = false;
		}
	},
	beforeRouteEnter(to, from, next) {
    /*
		*简历发布来源：微信：70百度：71头条：70支付宝：70
		*/
		if([70,71].indexOf(parseInt(util.getParamVal('sourceid'),10)) > -1) {
			window.clickLog && clickLog("from=page2_show");
		}
		next();
  },
};
</script>
<style lang='scss'>
@import "../../assets/style/public";
// .expand-transition {
// 	transition: all 1s ease;
// }

.expect-job {
	height: 100%;
	background: #f6f6f6;
}

.basic-info-save-box {
	background: #f6f6f6;
	padding: px2rem(40px) 0;
}

.resume-create {
	width: px2rem(550px);
	height: px2rem(88px);
	line-height: px2rem(88px);
	background: $orange;
	text-align: center;
	font-size: px2rem(34px);
	color: #ffaa96;
	z-index: 9999;
	margin: auto;
	border-radius: 2px;
}

.v5-loading {
	background-color: rgba(255, 255, 255, 0);
}

.v5-toast .v5-toast-content{
	white-space: normal;
	max-width: 80%;
	text-align: left;
}
</style>



// WEBPACK FOOTER //
// index.vue?55ed0b88